import { EmojiRenderer } from "@circle-react-shared/EmojiRenderer";
import { Icon } from "@circle-react-shared/Icon";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { Space } from "@circle-react/types";
import type { MouseEvent } from "react";

import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";
import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";
import { useThemeContext } from "@/react/providers/Theme";

export interface SpaceSelectButtonProps {
  defaultLabel?: string;
  disabled?: boolean;
  selectedSpace?: Space;
  shouldDisplayHomepage?: boolean;
  shouldShowEmoji?: boolean;
  toggleDropdown?: (event: MouseEvent<HTMLButtonElement>) => void;
  value?: number | null;
  variant?: string;
}

export const SpaceSelectButton = ({
  selectedSpace,
  toggleDropdown,
  shouldShowEmoji,
  value,
  shouldDisplayHomepage,
  disabled,
  defaultLabel = t("search_space"),
}: SpaceSelectButtonProps) => {
  const isHomeSpace = shouldDisplayHomepage && value === 0;
  const spaceLabel = selectedSpace?.name || "";
  const homeLabel = isHomeSpace ? t("feed") : "";
  const label = spaceLabel || homeLabel || defaultLabel;

  const { currentAppearance } = useThemeContext();

  return (
    <button
      type="button"
      className={legacyClassNames("react-space-selector__space-btn", {
        "cursor-not-allowed opacity-50": disabled,
      })}
      disabled={disabled}
      onClick={toggleDropdown}
    >
      <div
        className={classNames(
          legacyClassNames("react-space-selector__space-name"),
          {
            "flex gap-2.5": shouldShowEmoji,
          },
        )}
      >
        {shouldShowEmoji && selectedSpace && (
          <EmojiRenderer
            className="flex !h-5 !w-5 items-center justify-center"
            emoji={selectedSpace.emoji}
            appearance={currentAppearance}
            customEmojiUrl={selectedSpace.custom_emoji_url}
            customEmojiDarkUrl={selectedSpace.custom_emoji_dark_url}
          />
        )}
        <Typography.LabelMd>{label}</Typography.LabelMd>
      </div>{" "}
      <div className="text-dark flex">
        <Icon type="20-chevron-down-sm" size={20} />
      </div>
    </button>
  );
};
